<div class="page-shell">
  <div class="page">
    <div class="hero">
      <div class="hero-text">
        <span class="eyebrow">Atlas</span>
        <h2>Payment received</h2>
        <p>{{ statusMessage }}</p>
      </div>
      <div class="hero-panel">
        <div class="hero-status-row">
          <div class="step-pill">{{ statusLabel }}</div>
          @if (!ready && !provisioningFailed) {
          <div class="provisioning-spinner" aria-hidden="true"></div>
          }
        </div>
        <div class="hero-title">{{ ready ? 'Atlas ready' : 'Provisioning your secure environment' }}</div>
        <div class="hero-subtitle">{{ ready ? 'You can continue when ready.' : 'We will email you when setup completes. This process takes about 5 minutes.' }}</div>
      </div>
    </div>

    <section class="card">
      <h3>{{ ready ? 'Next steps' : 'Provisioning status' }}</h3>
      <p>
        @if (ready) {
        Atlas is ready. You can continue to login now, and you will also receive an email confirmation.
        }
        @if (!ready && !provisioningFailed) {
        Your payment has been accepted. Atlas provisioning happens asynchronously after checkout, so this page will update when the environment is ready.
        }
        @if (!ready && provisioningFailed) {
        Your payment has been accepted, but provisioning needs attention. We will follow up by email once Atlas is available.
        }
      </p>
      @if (tenantId) {
      <div class="helper tenant-id">Tenant ID: {{ tenantId }}</div>
      }
      @if (!ready && !provisioningFailed) {
      <div class="helper">
        We will send an email as soon as Atlas setup is complete. You do not need to keep this page open.
      </div>
      }
      @if (provisioningFailed) {
      <div class="helper">
        If this status does not clear, support intervention is required before Atlas login will be available.
      </div>
      }
      @if (!tenantId && !returnUrl) {
      <div class="helper">
        If you came from the portal, return there to manage subscriptions.
      </div>
      }
    </section>

    <div class="actions page-actions">
      @if (ready) {
      <a class="primary-link" [href]="atlasUrl">Proceed to Atlas login</a>
      }
    </div>
  </div>
</div>
